// const disqus_shortname = 'tac1';
const disqus_shortname = 'tac1';
const disqus_js_url = '//' + disqus_shortname + '.disqus.com/embed.js';

export default function comments(element) {
    let $element = $(element);
    const disqusMountingDivExists = $element.find('#disqus_thread').length;

    if (disqusMountingDivExists) {
        $('body').append($(`<script async src="${disqus_js_url}"></script>`));

        loadDisqusScript({
            newIdentifier: $element.data('id'),
            newUrl: $element.data('url'),
            newTitle: $element.data('title'),
            newLanguage: 'en'
        });
    } else {
        $element.on(
            'click',
            toggleCommentsHandler.bind(null, { parentElement: element })
        );
    }
}

function toggleCommentsHandler({ parentElement }) {
    const iconClassUp = 'fa-chevron-up';
    const iconClassDown = 'fa-chevron-down';
    let $togglerBtn = $(parentElement).find('.js-comments-icon');

    if ($togglerBtn.hasClass(iconClassDown)) {
        mountDisqus(parentElement);

        /* flip toggle-icon */
        $togglerBtn.removeClass(iconClassDown).addClass(iconClassUp);

        $('#disqus_thread').slideDown();
    } else {
        /* flip toggle-icon */
        $togglerBtn.removeClass(iconClassUp).addClass(iconClassDown);

        /* hides and destroys disqus instance (animated) */
        $('#disqus_thread').slideUp(
            ('normal',
            function() {
                $(this).remove();
            })
        );
    }

    /* flip every toggle-icon to face down (except current clicked icon) */
    $('.js-comments-icon')
        .not($togglerBtn)
        .each(function(i, el) {
            $(el)
                .removeClass(iconClassUp)
                .addClass(iconClassDown);
        });
}

function mountDisqus(parentElement) {
    let $parent = $(parentElement);

    /* remove any other comment-box in the page */
    $('#disqus_thread').remove();

    /* create a new comment-box for disqus to mount on */
    $parent.append($('<div id="disqus_thread"></div>'));

    loadDisqusScript({
        newIdentifier: $parent.data('id'),
        newUrl: $parent.data('url'),
        newTitle: $parent.data('title'),
        newLanguage: 'en'
    });

    /* smooth scroll */
    setTimeout(() => {
        $('html, body').animate(
            {
                scrollTop: $('#disqus_thread').offset().top - 65
            },
            500
        );
    }, 100);
}

function loadDisqusScript(config) {
    if (config) {
        /*
         * Disqus Config:
         * https://help.disqus.com/en/articles/1717084-javascript-configuration-variables
         *
         * coupling a comments-thread with a post using the post url(config.newUrl)
         * will ensure we load the same thread for the same post
         */
        window.disqus_config = function() {
            this.page.identifier = config.newIdentifier;
            this.page.url = config.newUrl;
            this.page.title = config.newTitle;
            this.language = config.newLanguage;
        };
    }

    /* if disqus script isn't loaded */
    if (!$(`[src="${disqus_js_url}"`).length) {
        $('body').append($(`<script async src="${disqus_js_url}"></script>`));
    } else {
        window.DISQUS.reset({
            reload: true,
            config: window.disqus_config || function() {}
        });
    }
}
